import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { GepjarmuService } from '../gepjarmu.service';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';

/*  GÉPJÁRMŰ – Költségek és lejáratok.
 *   Költségek: tankolás, szerviz, biztosítás, matrica, mosás, lízing, parkolás – járművenként / évre, összesítővel.
 *     A tankolás km-állása óraállás-pont is lesz a járműnél. Szerkesztési zár: gepjarmu_koltseg.
 *   Lejáratok: forgalmi, műszaki vizsga, KGFB, CASCO, matrica … – a lejárt piros, a figyelmeztetési időn belüli
 *     sárga; lezárás (megújítva) után a kezdőlap nem jelzi. Szerkesztési zár: gepjarmu_esemeny. */
@Component({
  selector: 'app-gj-koltsegek',
  templateUrl: './koltsegek.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../gepjarmu-shared.scss'],
})
export class GjKoltsegekComponent implements OnInit, OnDestroy {
  nezet: 'koltsegek' | 'lejaratok' = 'koltsegek';
  sz: any = null;
  jarmuvek: any[] = [];
  // költségek
  jarmuSzuro = '';
  fajtaSzuro = '';
  kereso = '';
  adat: any = { sorok: [], osszesen: { netto: 0, afa: 0, brutto: 0, liter: 0, db: 0 }, fajtankent: [] };
  szerk: any = null;
  zar: SzerkZar | null = null;
  // lejáratok
  esemenyek: any[] = [];
  lejaratJarmu = '';
  lezartak = false;
  eszerk: any = null;
  ezar: SzerkZar | null = null;
  ment = false;
  betolt = false;
  private zarKor = 0;
  private ezarKor = 0;
  private sub?: Subscription;
  private qsub?: Subscription;

  constructor(public gj: GepjarmuService, private route: ActivatedRoute, private toast: ToastController, private alert: AlertController,
    private szerkZar: SzerkZarService) {}
  get u() { return this.gj.aktiv.ugyfelId; }
  get ir() { return this.gj.ir; }
  get ev() { return this.gj.aktiv.ev; }
  get zarolt() { return !!this.zar && !this.zar.irhato; }
  get ezarolt() { return !!this.ezar && !this.ezar.irhato; }

  async ngOnInit() {
    await this.gj.init();
    try { this.sz = await this.gj.get('/szotarak'); } catch { this.sz = null; }
    this.qsub = this.route.queryParamMap.subscribe((p) => { if (p.get('ful') === 'lejaratok') this.nezet = 'lejaratok'; });
    this.sub = this.gj.aktiv$.subscribe(() => this.frissit());
  }
  ngOnDestroy() { this.sub?.unsubscribe(); this.qsub?.unsubscribe(); this.zarElenged(); this.ezarElenged(); }

  async frissit() {
    if (!this.u) { this.jarmuvek = []; this.esemenyek = []; this.adat = { sorok: [], osszesen: {}, fajtankent: [] }; return; }
    this.betolt = true;
    try {
      this.jarmuvek = await this.gj.get(`/jarmuvek/${this.u}`);
      await Promise.all([this.koltsegBetolt(), this.esemenyBetolt()]);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült betölteni.'); }
    finally { this.betolt = false; }
  }
  async koltsegBetolt() {
    const p = new URLSearchParams({ ev: String(this.ev) });
    if (this.jarmuSzuro) p.set('jarmu', this.jarmuSzuro);
    if (this.fajtaSzuro) p.set('fajta', this.fajtaSzuro);
    this.adat = await this.gj.get(`/koltsegek/${this.u}?${p.toString()}`);
  }
  async esemenyBetolt() { this.esemenyek = await this.gj.get(`/esemenyek/${this.u}${this.lejaratJarmu ? `?jarmu=${this.lejaratJarmu}` : ''}`); }
  async szuroValt() { try { await this.koltsegBetolt(); } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült betölteni.'); } }
  async lejaratSzuroValt() { try { await this.esemenyBetolt(); } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült betölteni.'); } }

  lista(obj: any): { k: string; v: string }[] { return Object.entries(obj || {}).map(([k, v]) => ({ k, v: String(v) })); }
  get valaszthatoJarmuvek() { return this.jarmuvek.filter((j) => j.aktiv || j.id === this.szerk?.jarmu_id || j.id === this.eszerk?.jarmu_id); }
  get lathato(): any[] {
    const k = this.kereso.trim().toLowerCase();
    return (this.adat.sorok || []).filter((s: any) => !k || [s.leiras, s.partner, s.bizonylatszam, s.rendszam, s.fajta_nev].some((x) => String(x || '').toLowerCase().includes(k)));
  }
  ft(v: any, t = 0) { return v == null || v === '' ? '' : Number(v).toLocaleString('hu-HU', { minimumFractionDigits: t, maximumFractionDigits: t || 2 }); }
  get tankolas() { return this.szerk?.fajta === 'uzemanyag'; }
  get egysegar(): number | null {
    const s = this.szerk;
    const l = Number(String(s?.liter ?? '').replace(',', '.'));
    const b = Number(String(s?.brutto ?? '').replace(',', '.'));
    return l > 0 && b > 0 ? Math.round((b / l) * 100) / 100 : null;
  }

  /* ── költség szerkesztő ── */
  uj() {
    this.zarElenged();
    const elso = this.jarmuSzuro && this.jarmuSzuro !== 'nincs' ? this.jarmuSzuro : (this.jarmuvek.filter((j) => j.aktiv).length === 1 ? this.jarmuvek.find((j) => j.aktiv).id : null);
    this.szerk = { id: null, jarmu_id: elso, datum: new Date().toISOString().slice(0, 10), fajta: this.fajtaSzuro || 'uzemanyag', leiras: '', netto: null, afa: null, brutto: null,
      liter: null, km_allas: null, bizonylatszam: '', partner: '', megjegyzes: '' };
  }
  nyit(s: any) { this.szerk = { ...s }; this.zarFoglal(String(s.id)); }
  private async zarFoglal(id: string) {
    this.zarElenged();
    if (!this.ir) return;
    const kor = this.zarKor;
    const z = await this.szerkZar.foglal('gepjarmu', 'gepjarmu_koltseg', id, { ujratolt: () => this.ujratolt(id) });
    if (kor !== this.zarKor || String(this.szerk?.id) !== id) { z?.felenged(); return; }
    this.zar = z;
  }
  private zarElenged() { this.zarKor++; this.zar?.felenged(); this.zar = null; }
  bezar() { this.szerk = null; this.zarElenged(); }
  private async ujratolt(id: string) {
    await this.koltsegBetolt();
    const s = (this.adat.sorok || []).find((x: any) => String(x.id) === id);
    if (s && String(this.szerk?.id) === id) this.szerk = { ...s };
  }
  /*  27%-os ÁFA a bruttóból (a leggyakoribb eset) – csak segítség, a mező átírható. */
  afaBruttobol(kulcs = 27) {
    const b = Number(String(this.szerk.brutto ?? '').replace(',', '.'));
    if (!(b > 0)) return;
    this.szerk.netto = Math.round((b / (1 + kulcs / 100)) * 100) / 100;
    this.szerk.afa = Math.round((b - this.szerk.netto) * 100) / 100;
  }
  /*  Ha a nettó és az ÁFA adott, a bruttó számolódik (a kiszolgáló is így tesz, és ellenőriz). */
  osszegValt() {
    const s = this.szerk;
    const n = Number(String(s.netto ?? '').replace(',', '.')), a = Number(String(s.afa ?? '').replace(',', '.'));
    if (s.netto !== null && s.netto !== '' && s.afa !== null && s.afa !== '' && Number.isFinite(n) && Number.isFinite(a)) s.brutto = Math.round((n + a) * 100) / 100;
  }
  async mentes() {
    if (this.zarolt || this.ment) return;
    const s = this.szerk;
    this.ment = true;
    try {
      if (s.id) await this.gj.put(`/koltseg/${s.id}`, s); else await this.gj.post(`/koltseg/${this.u}`, s);
      this.bezar(); this.ok('Költség mentve.'); await this.koltsegBetolt();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
    finally { this.ment = false; }
  }
  async torol() {
    if (this.zarolt || !this.szerk?.id) return;
    const s = this.szerk;
    const a = await this.alert.create({
      header: 'Költség törlése', message: `Biztosan törlöd a(z) ${s.datum} – ${s.fajta_nev} (${this.ft(s.brutto)} Ft) tételt?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: () => { this.torolVeg(s.id); } }],
    });
    await a.present();
  }
  private async torolVeg(id: string) {
    try { await this.gj.del(`/koltseg/${id}`); this.bezar(); this.ok('Költség törölve.'); await this.koltsegBetolt(); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
  }

  /* ── lejáratok ── */
  get esemenyLathato(): any[] { return this.esemenyek.filter((e) => this.lezartak || !e.lezarva); }
  get lejartDb() { return this.esemenyek.filter((e) => e.allapot === 'lejart').length; }
  get hamarosanDb() { return this.esemenyek.filter((e) => e.allapot === 'hamarosan').length; }
  allapotNev(e: any): string {
    if (e.allapot === 'lezarva') return 'lezárva';
    if (e.allapot === 'nincs_datum') return 'nincs dátum';
    if (e.hatra_nap < 0) return `lejárt (${-e.hatra_nap} napja)`;
    if (e.hatra_nap === 0) return 'ma jár le';
    return e.allapot === 'hamarosan' ? `${e.hatra_nap} nap múlva` : `rendben (${e.hatra_nap} nap)`;
  }
  allapotJel(e: any): string { return ({ lejart: 'hiba', hamarosan: 'figyelmeztetes', rendben: 'kesz', lezarva: 'nincs', nincs_datum: 'var' } as any)[e.allapot] || 'nincs'; }
  euj(alap: any = {}) {
    this.ezarElenged();
    this.eszerk = { id: null, jarmu_id: this.lejaratJarmu || null, fajta: 'muszaki', megnevezes: '', okmanyszam: '', ervenyes_ig: null, figyelmeztet_nap: 30,
      lezarva: false, megjegyzes: '', ...alap };
  }
  enyit(e: any) { this.eszerk = this.eszerkAdat(e); this.ezarFoglal(String(e.id)); }
  private eszerkAdat(e: any) { return { ...e, lezarva: !!Number(e.lezarva), megjegyzes: e.megjegyzes || '' }; }
  private async ezarFoglal(id: string) {
    this.ezarElenged();
    if (!this.ir) return;
    const kor = this.ezarKor;
    const z = await this.szerkZar.foglal('gepjarmu', 'gepjarmu_esemeny', id, { ujratolt: () => this.eujratolt(id) });
    if (kor !== this.ezarKor || String(this.eszerk?.id) !== id) { z?.felenged(); return; }
    this.ezar = z;
  }
  private ezarElenged() { this.ezarKor++; this.ezar?.felenged(); this.ezar = null; }
  ebezar() { this.eszerk = null; this.ezarElenged(); }
  private async eujratolt(id: string) {
    await this.esemenyBetolt();
    const e = this.esemenyek.find((x) => String(x.id) === id);
    if (e && String(this.eszerk?.id) === id) this.eszerk = this.eszerkAdat(e);
  }
  async ementes(utana?: 'uj') {
    if (this.ezarolt || this.ment) return;
    const e = this.eszerk;
    this.ment = true;
    try {
      if (e.id) await this.gj.put(`/esemeny/${e.id}`, e); else await this.gj.post(`/esemeny/${this.u}`, e);
      this.ebezar(); this.ok('Mentve.'); await this.esemenyBetolt();
      //  „Lezárás és új”: a megújított okmány következő érvényessége ugyanarra a járműre, ugyanazzal a fajtával.
      if (utana === 'uj') this.euj({ jarmu_id: e.jarmu_id, fajta: e.fajta, megnevezes: e.megnevezes, figyelmeztet_nap: e.figyelmeztet_nap });
    } catch (err: any) { this.hiba(err?.error?.error || 'Nem sikerült menteni.'); }
    finally { this.ment = false; }
  }
  async lezarEsUj() { if (!this.eszerk) return; this.eszerk.lezarva = true; await this.ementes('uj'); }
  async etorol() {
    if (this.ezarolt || !this.eszerk?.id) return;
    const e = this.eszerk;
    const a = await this.alert.create({
      header: 'Lejárat törlése', message: `Biztosan törlöd: ${e.megnevezes || e.fajta_nev}${e.rendszam ? ' (' + e.rendszam + ')' : ''}?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: () => { this.etorolVeg(e.id); } }],
    });
    await a.present();
  }
  private async etorolVeg(id: string) {
    try { await this.gj.del(`/esemeny/${id}`); this.ebezar(); this.ok('Törölve.'); await this.esemenyBetolt(); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 5200, color: 'danger' })).present(); }
}
